export default {
  title: 'Nulstil adgangskode',
  description: 'Vi sender et link til nulstilling af adgangskode til din e-mail.',
  sent: 'E-mailen er sendt.',

  form: {
    email: {
      title: 'E-mail',
      placeholder: 'Indtast e-mail',
    },
    button: {
      title: 'Nulstil adgangskode',
    },
    error_messages: {
      error1: 'Manglende oplysninger',
    },
  },
};
